import { API_URL } from "@/constants/envVariables";

import { handleApiResponse } from "@/api/handleApiResponse";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

export const postDisbursementFile = async (token: string, disbursementId: string, file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_URL}/disbursements/${disbursementId}/instructions`, {
    method: "POST",
    credentials: getAuthCredentials(),
    headers: {
      ...buildAuthHeaders(token),
    },
    body: formData,
  });

  return handleApiResponse(response);
};
